import React from "react";
import { Col, Row } from "react-bootstrap";
const HeaderSection = (props) => {
    return (React.createElement(Row, { className: "mx-0" },
        React.createElement(Col, { lg: 12, className: "header-section px-0" },
            React.createElement("span", null, props.title))));
};
export default HeaderSection;
